import React, { useEffect } from "react";
import PrimaryButton from "../../shared/Button/PrimaryButton";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import SplitterImgBox from "../../shared/SplitterImgBox";
import ServiceContainer from "./ServiceContainer";
import CustomCard from "../../shared/Card/CustomCard";
import BenefitsCard from "../../shared/Card/BenefitsCard";
import { getImageURL } from "../../utils/imageUrl";

export default function ServicePreview() {
    const location = useLocation();
    const data = location.state;
    const { onSubmit, history, loading, setData } = ServiceContainer();

    useEffect(() => {
        if (!data) history.goBack();
        setData({ ...data });
    }, [data, history, setData]);

    return (
        <>
            <CustomCard title={"Preview Service"}>
                {/* banner start */}
                <div className="py-7">
                    <div className="grid align-items-center">
                        <div className="col-12 lg:col-5 p-4">
                            <h2 className="heading text-4xl font-semibold">{data?.serviceName}</h2>
                            <p className="text-gray-color line-height-2 text-lg font-normal">{data?.description}</p>
                            <ul className="p-0 mb-4">
                                {data?.features?.map((feature) => {
                                    return (
                                        <li className="flex gap-3 align-items-center mb-3">
                                            <i className="pi pi-check"></i> <span className="text-gray-color">{feature?.description}</span>
                                        </li>
                                    );
                                })}
                            </ul>
                            <PrimaryButton label="Get Started" extraClassNames="" />
                        </div>
                        <div className="col-12 lg:col-7">
                            {data?.hasBeforeAfterImages ? (
                                <SplitterImgBox
                                    BeforeImg={data?.primaryBeforeImage && getImageURL(data?.primaryBeforeImage)}
                                    AfterImg={data?.primaryAfterImage && getImageURL(data?.primaryAfterImage)}
                                    label
                                />
                            ) : (
                                <img src={data?.primarySingleImage && getImageURL(data?.primarySingleImage)} alt="" className="w-full h-30rem" />
                            )}
                        </div>
                    </div>
                </div>
                {/* banner end */}

                <div className="py-7">
                    <h2 className="text-4xl heading rubik font-semibold">{data?.about?.title}</h2>
                    <p className="text-gray-color line-height-3">{data?.about?.description}</p>
                </div>
                {/* about virtual staging end */}

                {/* virtual staged property section start */}
                <div className="py-7">
                    {data?.hasBeforeAfterImages ? (
                        <>
                            <h2 className="text-4xl text-center heading rubik font-semibold">Before & After: {data?.secondaryImageTitle}</h2>
                            <SplitterImgBox
                                BeforeImg={data?.secondaryBeforeImage && getImageURL(data?.secondaryBeforeImage)}
                                AfterImg={data?.secondaryAfterImage && getImageURL(data?.secondaryAfterImage)}
                                label
                            />
                        </>
                    ) : (
                        <>
                            <h2 className="text-4xl text-center heading rubik font-semibold">{data?.secondaryImageTitle}</h2>
                            <img src={data?.secondarySingleImage && getImageURL(data?.secondarySingleImage)} alt="" className="w-full" height={600} />
                        </>
                    )}
                </div>

                {/* Benefits */}
                <div className="py-7">
                    <div className="container">
                        <h2 className="heading text-center text-4xl mb-4 rubik">{data?.benefitsTitle} </h2>
                        <div className="grid bg-white mt-7">
                            {data?.benefits?.map((item, index) => (
                                <BenefitsCard
                                    key={index}
                                    extraClass="text-center lg:col-4 lg:text-left"
                                    src={item?.iconImage && getImageURL(item?.iconImage)}
                                    title={item.title}
                                    detail={item.description}
                                    width={40}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                <div className="w-full text-right">
                    {data?.formType !== "VIEW" && <PrimaryButton extraClassName="w-2" label="Save Service" loading={loading} onClick={onSubmit} />}
                </div>
            </CustomCard>
        </>
    );
}
